import type { BasketItem } from "../page";

// A sale line whose quantity is more than the available stock (return and BOGO rows are exempt)
export const isBasketItemOverStock = (item: BasketItem): boolean =>
  !item.isReturnLine &&
  !item.isBogoFreeItem &&
  item.qty > 0 &&
  item.stock != null &&
  item.qty > item.stock;
